import { render, staticRenderFns } from "./StudyProgress.vue?vue&type=template&id=854187f6&scoped=true"
import script from "./StudyProgress.vue?vue&type=script&lang=js"
export * from "./StudyProgress.vue?vue&type=script&lang=js"
import style0 from "./StudyProgress.vue?vue&type=style&index=0&id=854187f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854187f6",
  null
  
)

export default component.exports